// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","text-center":"Footer_text-center__82NLt"};